import { httpGet } from '../../../utils/api.utils'; 
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../constants/external-constants';
import Moment from 'moment';
import {
    getInventoryUsageSpend,
    setInventoryUsageSpendError,
} from '../../../constants/model-reducers/external/inventory/circuit-details/usagespend.settings';

const defaultState = () => ({
    isInventoryUsageSpendLoaded: false,
    isInventoryUsageSpendError: false,
    inventoryUsageSpendItems: null,
});

const initialState = defaultState();

export const inventoryUsageSpendActions = {
    getInventoryUsageSpend: (circuitId, financeAccountId, date) => async (dispatch, state) => {

        let startDate;
        if (date === undefined) {
            startDate = Moment().startOf('day');
        }
        else {
            startDate = Moment.utc(date).add(1, 'days');
        }
        var filterMonth = startDate.month();
        var filterYear = startDate.year();

        var usageSpendItems = await httpGet('external/inventory/getInventoryUsageSpend/' + circuitId + '/' + filterMonth + '/' + filterYear + '/' + financeAccountId);
        if (usageSpendItems.ok === false) {
            dispatch({
                type: setInventoryUsageSpendError,
                isInventoryUsageSpendError: true,
                isInventoryUsageSpendLoaded: false
            });
        }
        else {
            dispatch({
                type: getInventoryUsageSpend,
                usageSpendItems: Object.keys(usageSpendItems).length > 0 ? usageSpendItems : null,
                isInventoryUsageSpendLoaded: true,
                isInventoryUsageSpendError: false
            });
        }
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInventoryUsageSpend:
            return {
                ...state,
                inventoryUsageSpendItems: action.usageSpendItems,
                isInventoryUsageSpendLoaded: action.isInventoryUsageSpendLoaded,
                isInventoryUsageSpendError: action.isInventoryUsageSpendError
            };
        default:
            return state;
    }
};